import { getCookie, setCookie } from "~/utils/cookie";
import { isClient } from "~/utils/app";

export const FINGERPRINT_COOKIE_KEY = "fingerprint_id";
export const FINGERPRINT_HEADER = "X-Fingerprint-Id";

export const getFingerprintId = (req) => {
  return getCookie(FINGERPRINT_COOKIE_KEY, req);
};

export const ensureFingerprint = async () => {
  if (!isClient()) {
    return null;
  }

  const existingId = getFingerprintId();
  if (existingId) {
    return existingId;
  }

  try {
    const FingerprintJS = await import("@fingerprintjs/fingerprintjs");
    const agent = await FingerprintJS.load();
    const { visitorId } = await agent.get();

    if (visitorId) {
      setCookie(FINGERPRINT_COOKIE_KEY, visitorId, { expires: 365 });
      return visitorId;
    }
  } catch (error) {
    console.error("fingerprint generation failed", error);
  }

  return null;
};
